<template>
  <modal name="modal-add-invoice" height="auto" :width="560"
         :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>ADD INVOICE</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <template v-if="postData">
      <form method="post" action="" ref="form" @submit.prevent="doCreate">
        <div class="form-group">
          <label for="name">Name <span class="text-danger">*</span></label>
          <input type="text" name="name" id="name" ref="inputName"
                 :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.name">
          <div class="invalid-feedback">{{ errors.first('name') }}</div>
        </div>
        <div v-if="!job" class="form-group">
          <label for="job_id">Job</label>
          <v-select id="job_id" v-model="postData.job_id" :options="allJobs" class="form-control" :reduce="item => item.id"
                    label="name" :searchable="true" :placeholder="'- Select job'"></v-select>
        </div>
        <div v-if="!job" class="form-group">
          <label for="client_id">Client <span class="text-danger">*</span></label>
          <v-select id="client_id" v-model="postData.client_id" :options="allClients" class="form-control" :reduce="item => item.id"
                    label="name" :searchable="true" :placeholder="'- Select client'"></v-select>
        </div>
        <div class="form-group">
          <label>Description</label>
          <textarea type="text" class="form-control" rows="6" v-model="postData.description" placeholder="Descrpition"></textarea>
        </div>
        <div class="pt-2 btns btns-2">
          <beat-loader v-if="state == 'saving'"></beat-loader>
          <template v-else>
            <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
            <button type="button" class="btn btn-outline-gray" @click="closeModal">Cancel</button>
          </template>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import { mapState } from 'vuex'
  import ServiceInvoice from '@/services/invoice'
  import BeatLoader from 'vue-spinner/src/BeatLoader'

  export default {
    components: {
      BeatLoader,
    },
    data () {
      return {
        state: '',
        postData: false,
      }
    },
    props: ['value', 'job'],
    computed: mapState({
      allClients: state => state.option.clients,
      allJobs: state => state.option.jobs
    }),
    watch: {
      job: 'init',
      value ( newVal ) {
        let self = this;
        if ( newVal ) {
          self.$modal.show('modal-add-invoice', {});
          setTimeout(() => {
            self.$refs.inputName.focus();
          }, 200);
        }
      },
      'postData.job_id': function (newVal) {
        if(newVal) {
          let job = window.getObjectByKeyValue(this.allJobs, 'id', newVal);
          if(job)
            this.postData.client_id = job.client_id;
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        self.resetForm();
        if (typeof self.job != 'undefined') {
          self.postData.job_id = self.job.id;
          self.postData.client_id = self.job.client_id
        }
      },
      resetForm () {
        let self = this;
        self.postData = {
          name: '',
          client_id: '',
          status: 'pending',
          job_id: '',
          description: ''
        };
      },
      closeModal () {
        this.$modal.hide('modal-add-invoice');
      },
      doCreate ( ) {
        let self = this;
        if (self.state == 'saving') {
          return;
        }

        self.$validator.validateAll()
          .then(ok => {
            if ( ok ) {
              if(!self.postData.client_id) {
                self.$notify({
                  type: 'error',
                  text: 'Please select the client'
                });
                return false;
              }
              self.state = 'saving';

              ServiceInvoice.create(self.postData, function(invoice){
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: 'Invoice "<strong>' + invoice.name + '</strong>" added successfully.'
                });
                self.resetForm();
                self.$emit('added', invoice);
                self.closeModal();
              },function(error){
                window.console.log(error);
                self.state = '';
              });
            }
          });
      }
    }
  }
</script>
